'use client'

import { useEffect, useRef } from 'react'
import { useTracking } from '@/app/contexts/tracking-context'
import type { ArticleTrackingParams } from '@/app/utils/article-tracking'

// Plan Welyft « view_comment » : affichage de la section commentaires. Le dataLayer garde le nom
// historique `affichage_commentaire` (GTM le renomme, `report.main` le lit encore sous ce nom).
export default function CommentsViewTracker({ articleParams }: { articleParams?: ArticleTrackingParams }) {
    const { track } = useTracking()
    const sentinel = useRef<HTMLSpanElement>(null)
    const hasTracked = useRef(false)

    useEffect(() => {
        const node = sentinel.current
        if (!node || typeof IntersectionObserver === 'undefined') return

        const observer = new IntersectionObserver((entries) => {
            if (hasTracked.current || !entries.some((entry) => entry.isIntersecting)) return
            hasTracked.current = true
            track({ event: 'affichage_commentaire', ...articleParams })
            observer.disconnect()
        })
        observer.observe(node)

        return () => observer.disconnect()
    }, [track, articleParams])

    return <span ref={sentinel} aria-hidden="true" />
}
